/** @jsx jsx */
import * as React from "react";
import { css, InterpolationWithTheme, jsx } from "@emotion/core";
import { IFetchScheduledInterventionsResponse } from "../../../../../models/IFetchScheduledInterventions";
import { IHistoryTableData } from "../../../IntervantionsHistory";
import Slider, { Settings } from "react-slick";
import AppUtils from "../../../../../utils/AppUtils";
import { interventionsHistoryStyles } from "../../../../../styles/Interventions/interventionsHistory";
import { interventionsDailyViewStyles } from "../../../../../styles/Interventions/interventionsDailyView";


interface IIntervantionsHistoryProps {
    historyData: Array<IFetchScheduledInterventionsResponse[]>;
    isMobile: boolean;
    data: IHistoryTableData[];
}

const TABLE_PROPERTIES = {
    STARTDATE: "startDate",
    ENDDATE: "endDate",
    TOTAL: "total",
    COMPLETE: "completePct",
    INCOMPLETE: "incompletePct",
    NORESPONSE: "noResPct"

}

export const InterventionsHistoryMobile: React.FC<IIntervantionsHistoryProps> = props => {
    const { data } = props;

    const carousalSettings: Settings = {
        dots: true,
        infinite: false,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: false,
    }

    const groupHistoryData = (historyData: IHistoryTableData[]) => {
        if (!historyData)
            return {};
        const groupedData = historyData.reduce((res, acc) => ({ ...res, [acc.taskId]: acc }), {})
        return groupedData;
    }

    const getTableColumnValue = (activityData: any, property: string) => {
        const { total, startDate, endDate, scheduledTask, doneTask, missedTask } = activityData;

        switch (property) {
            case TABLE_PROPERTIES.STARTDATE: return (AppUtils.getFormattedShortDate(startDate))
            case TABLE_PROPERTIES.ENDDATE: return (AppUtils.getFormattedShortDate(endDate))
            case TABLE_PROPERTIES.TOTAL: return total;
            case TABLE_PROPERTIES.INCOMPLETE: {
                const incomplete: number = scheduledTask + missedTask;
                const incompletePct: number = Math.floor((incomplete / total) * 100);
                return `${incomplete} (${incompletePct})%`
            }
            case TABLE_PROPERTIES.COMPLETE: {
                const completePct: number = Math.floor((doneTask / total) * 100);
                return `${doneTask} (${completePct})%`
            }
            case TABLE_PROPERTIES.NORESPONSE: {
                const incomplete: number = scheduledTask + missedTask;
                const noRes: number = total - (doneTask + incomplete);
                const noResPct: number = Math.floor((noRes / total) * 100);
                return `${noRes} (${noResPct})%`
            }
        }

    }

    const getSliderItems = () => {
        const tableHeaders = [
            { label: "Start Date", property: TABLE_PROPERTIES.STARTDATE },
            { label: "End Date", property: TABLE_PROPERTIES.ENDDATE },
            { label: "Total", property: TABLE_PROPERTIES.TOTAL },
            { label: "Complete (%)", property: TABLE_PROPERTIES.COMPLETE },
            { label: "Incomplete (%)", property: TABLE_PROPERTIES.INCOMPLETE },
            { label: "No Response (%)", property: TABLE_PROPERTIES.NORESPONSE }
        ]
        const activityData = groupHistoryData(data)

        let slideItems: JSX.Element[] = [];

        slideItems = tableHeaders.map((header, index) => {
            return (
                <div css={interventionsHistoryStyles.slideItemWrapper} key={`header-${index}`}>
                    <div css={interventionsHistoryStyles.tableData}>
                        <div css={interventionsHistoryStyles.columnHeader}>{header.label}</div>
                        <div css={interventionsDailyViewStyles.divider}></div>
                    </div>
                    {
                        Object.values(activityData).map((value, valueIndex) => {
                            let dataForCurrentDate = getTableColumnValue(value, header.property)

                            return (
                                <div key={`value-${valueIndex}`} css={{ background: (valueIndex % 2) ? "#f8f5f5" : "#ffffff" }} >
                                    <div css={interventionsHistoryStyles.colData}>{dataForCurrentDate}</div>
                                </div>)
                        })}
                </div>
            )
        })
        return slideItems;
    }

    return (
        <div css={interventionsHistoryStyles.historyViewContainer}>
            <div css={interventionsHistoryStyles.leftContainer}>
                <div css={interventionsHistoryStyles.tableHeader}>Activity List</div>
                <div css={interventionsDailyViewStyles.divider}></div>
                <div css={interventionsHistoryStyles.activityList}>
                    {data && data.map(({ activityName }, idx) => {
                        return (
                            <div key={idx} css={{ background: (idx % 2) ? "#f8f5f5" : "#ffffff" }} >
                                <div css={interventionsHistoryStyles.colData}>{activityName}</div>
                            </div>
                        )
                    })
                    }
                </div>
            </div>
            <div css={interventionsHistoryStyles.rightContainer}>

                <Slider {...carousalSettings}>
                    {getSliderItems()}
                </Slider>
            </div>

        </div>
    )
}